import React from 'react';
import ProjectOversightLayout from './projectOversight/ProjectOversightLayout';

const ProjectAssessments = () => <ProjectOversightLayout mode="assessment" />;

export default ProjectAssessments;
